import React from "react"
import { LockOutlined, UserOutlined } from "@ant-design/icons"
import { Button, Checkbox, Form, Input } from "antd"
import { Link } from "react-router-dom"
import NaverLogin from "./NaverLogin"




const FormLogin = () => {
   const onFinish = (values) => {
      console.log("Received values of form: ", values)
   }

   return (
      <>
         <Form
            name='normal_login'
            className='login-form'
            initialValues={{ remember: true }}
            onFinish={onFinish}
         >
            <Form.Item
               name='아이디'
               rules={[{ required: true, message: "아이디를 입력하세요" }]}
            >
               <Input
                  prefix={<UserOutlined className='site-form-item-icon' />}
                  placeholder='아이디'
               />
            </Form.Item>
   
   
            <Form.Item
               name='비밀번호'
               rules={[{ required: true, message: "비밀번호를 입력하세요" }]}
            >
               <Input
                  prefix={<LockOutlined className='site-form-item-icon' />}
                  type='password'
                  placeholder='비밀번호'
               />
            </Form.Item>
   
   
            <Form.Item>
               <Form.Item name='remember' valuePropName='checked' noStyle>
                  <Checkbox>로그인정보 기억하기 /</Checkbox>
               </Form.Item>
   
               <a className='login-form-forgot' href='noscript:'>
                  비밀번호 찾기
               </a>
            </Form.Item>
   
   
            <Form.Item>
               <Button
                  type='primary'
                  htmlType='submit'
                  className='login-form-button'
                  style={{marginRight : '20px'}}
               >
                  로그인
               </Button>
               혹은 <Link to="/">지금 회원가입</Link>
            </Form.Item>
         </Form>
         <NaverLogin />
      </>

   )
}

export default FormLogin
